// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bce2757f","455":"5930f5a6"}[chunkId] + ".chunk.js";
};